//
// Module for the Benefit Estimate wizard's Options step
//
rs.module("participant/benefit/estimates/create/wizard/optionsstep",

    ["common/select-helper", "common/visibility", "controls/components/event-banner"],

    function (selectHelper, visibility, eventBanner) {

        // Initialize the module
        function initialize(jsSelectors, codeValues, backendUrls, flags, participant, grids, beneficiaryOptionEnum) {

            // Booleans to indicate whether grid selection changed is fired during grid's first render or actual selection 
            var _beneficiariesGridExecuteSelectionChanged;
            var _recipientsGridExecuteSelectionChanged;

            var initialLoad = true;

            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);

            var separationTypeSelect = stepContainer.js(jsSelectors.separationTypeSelect);
            var separationSubTypeContainer = stepContainer.js(jsSelectors.separationSubTypeContainer);
            var separationSubTypeSelect = stepContainer.js(jsSelectors.separationSubTypeSelect);
            var separationSubTypeHidden = stepContainer.js(jsSelectors.separationSubTypeHidden);
            var separationSubTypeSelectHelper = selectHelper.getHelper(separationSubTypeSelect);
            var effectiveDatesAndAgesContainer = stepContainer.js(jsSelectors.effectiveDatesAndAgesContainer);
            var separationDateInput = stepContainer.js(jsSelectors.separationDateInput);
            var separationAgeInput = stepContainer.js(jsSelectors.separationAgeInput);
            var benefitEffectiveDateInput = stepContainer.js(jsSelectors.benefitEffectiveDateInput);
            var benefitEffectiveAgeInput = stepContainer.js(jsSelectors.benefitEffectiveAgeInput);
            var dropPlanContainer = stepContainer.js(jsSelectors.dropPlanContainer);
            var dropEntryDateInput = stepContainer.js(jsSelectors.dropEntryDateInput);
            var dropEntryAgeInput = stepContainer.js(jsSelectors.dropEntryAgeInput);
            var dropPlanSelect = stepContainer.js(jsSelectors.dropPlanSelect);
            var dropPlanSelectHelper = selectHelper.getHelper(dropPlanSelect);
            var incomeLevelingContainer = stepContainer.js(jsSelectors.incomeLevelingContainer);
            var applyIncomeLevelingCheckBox = stepContainer.js(jsSelectors.applyIncomeLevelingCheckBox);
            var socialSecurityBenefitAmountInput = stepContainer.js(jsSelectors.socialSecurityBenefitAmountInput);
            var socialSecurityStartAgeInput = stepContainer.js(jsSelectors.socialSecurityStartAgeInput);
            var backDropContainer = stepContainer.js(jsSelectors.backDropContainer);
            var applyBackDropCheckBox = stepContainer.js(jsSelectors.applyBackDropCheckBox);
            var backDropMonthsSelect = stepContainer.js(jsSelectors.backDropMonthsSelect);
            var backDropMonthsSelectHelper = selectHelper.getHelper(backDropMonthsSelect);
            var backDropDateInput = stepContainer.js(jsSelectors.backDropDateInput);
            var backDropDateHidden = stepContainer.js(jsSelectors.backDropDateHidden);

            var beneficiariesContainer = stepContainer.js(jsSelectors.beneficiariesContainer);
            var selectBeneficiaryRadio = stepContainer.js(jsSelectors.selectBeneficiaryRadio);
            var beneficiaryAccountPartyKeyHidden = beneficiariesContainer.js(jsSelectors.beneficiaryAccountPartyKeyHidden);
            var recipientsContainer = stepContainer.js(jsSelectors.recipientsContainer);
            var enterBeneficiaryRadio = stepContainer.js(jsSelectors.enterBeneficiaryRadio);
            var enterBeneficiaryContainer = stepContainer.js(jsSelectors.enterBeneficiaryContainer);
            var beneficiaryNameInput = enterBeneficiaryContainer.js(jsSelectors.beneficiaryNameInput);
            var beneficiaryNameInputHidden = enterBeneficiaryContainer.js(jsSelectors.beneficiaryNameInputHidden);
            var beneficiaryBirthDateInput = enterBeneficiaryContainer.js(jsSelectors.beneficiaryBirthDateInput);
            var beneficiaryBirthDateInputHidden = enterBeneficiaryContainer.js(jsSelectors.beneficiaryBirthDateInputHidden);
            var beneficiaryRelationshipSelect = enterBeneficiaryContainer.js(jsSelectors.beneficiaryRelationshipSelect);
            var beneficiaryRelationshipSelectHelper = selectHelper.getHelper(beneficiaryRelationshipSelect);
            var beneficiaryRelationshipSelectHidden = enterBeneficiaryContainer.js(jsSelectors.beneficiaryRelationshipSelectHidden);
            var beneficiaryFTSCheckBox = enterBeneficiaryContainer.js(jsSelectors.beneficiaryFTSCheckBox);
            var beneficiaryFTSCheckBoxHidden = enterBeneficiaryContainer.js(jsSelectors.beneficiaryFTSCheckBoxHidden);
            var noBeneficiaryContainer = stepContainer.js(jsSelectors.noBeneficiaryContainer);
            var noBeneficiaryRadio = noBeneficiaryContainer.js(jsSelectors.noBeneficiaryRadio);

            // Hookup separationTypeSelect change event
            separationTypeSelect.change(separationTypeChange);

            // Hookup date/age change events
            separationDateInput.change(_.debounce(separationDateChange, 500));
            separationAgeInput.change(_.debounce(separationAgeChange, 500));
            benefitEffectiveDateInput.change(_.debounce(benefitEffectiveDateChange, 500));
            benefitEffectiveAgeInput.change(_.debounce(benefitEffectiveAgeChange, 500));
            dropEntryDateInput.change(_.debounce(dropEntryDateChange, 500));
            dropEntryAgeInput.change(_.debounce(dropEntryAgeChange, 500));

            // Hookup beneficiary radio change events
            selectBeneficiaryRadio.change(beneficiaryRadioChange);
            enterBeneficiaryRadio.change(beneficiaryRadioChange);
            noBeneficiaryRadio.change(beneficiaryRadioChange);

            // Hookup beneficiary field change events
            beneficiaryNameInput.change(resetBeneficiaryGridSelections);
            beneficiaryBirthDateInput.change(resetBeneficiaryGridSelections);
            beneficiaryRelationshipSelect.change(resetBeneficiaryGridSelections);
            beneficiaryFTSCheckBox.change(resetBeneficiaryGridSelections);

            // Suppress enter key press on changing input fields
            separationDateInput.on("keydown", suppressEnterKeyPress);
            separationAgeInput.on("keydown", suppressEnterKeyPress);
            benefitEffectiveDateInput.on("keydown", suppressEnterKeyPress);
            benefitEffectiveAgeInput.on("keydown", suppressEnterKeyPress);
            dropEntryDateInput.on("keydown", suppressEnterKeyPress);
            dropEntryAgeInput.on("keydown", suppressEnterKeyPress);
            beneficiaryNameInput.on("keydown", suppressEnterKeyPress);
            beneficiaryBirthDateInput.on("keydown", suppressEnterKeyPress);

            // Default all dates/ages if page was initiated with a default Separation Date
            if (separationDateInput.val() && !separationAgeInput.val()) {
                separationDateChange();
            }

            // Handle separation sub type
            separationTypeChange();
            initialLoad = false;

            // Hookup backDropMonthsSelect change event
            backDropMonthsSelect.change(backDropMonthsChange);

            // Enable/Disable Income Leveling fields on applyIncomeLevelingCheckBox change
            applyIncomeLevelingCheckBox.change(function () {

                // Enable/disable Income Leveling fields
                socialSecurityBenefitAmountInput.setDisabled(!this.checked).val("").clearErrors();
                socialSecurityStartAgeInput.setDisabled(!this.checked).val("").clearErrors();

                // Also, enable/disable backDROP fields
                applyBackDropCheckBox.setDisabled(this.checked).setChecked(false);
                if (this.checked) {
                    backDropMonthsSelectHelper.setDisabled(this.checked).setValue("");
                    backDropMonthsSelect.clearErrors();
                    backDropDateInput.val("").clearErrors();
                    backDropDateHidden.val("").clearErrors();
                }
            });

            // Enable/Disable Income Leveling and BackDROP fields on applyBackDropCheckBox change
            applyBackDropCheckBox.change(function () {

                // Enable/disable backDROP fields
                backDropMonthsSelectHelper.setDisabled(!this.checked).setValue("");
                backDropMonthsSelect.clearErrors();
                backDropDateInput.val("").clearErrors();
                backDropDateHidden.val("").clearErrors();

                // Also, enable/disable Income Leveling fields
                applyIncomeLevelingCheckBox.setDisabled(this.checked).setChecked(false);
                if (this.checked) {
                    socialSecurityBenefitAmountInput.setDisabled(this.checked).val("").clearErrors();
                    socialSecurityStartAgeInput.setDisabled(this.checked).val("").clearErrors();
                }
            });

            // on beneficiaries grid selection changed,
            // switch to appropriate radio button
            grids.beneficiariesGrid.selectionChanged(function (values, rows) {

                if (_beneficiariesGridExecuteSelectionChanged) {
                    if (values.length > 0) {
                        selectBeneficiaryRadio.setChecked();
                        beneficiaryAccountPartyKeyHidden.val(values[0]);
                        enableDisableBeneficiaryEntryFields(false);
                    }
                }

                _beneficiariesGridExecuteSelectionChanged = true;
            });

            // on recipients grid selection changed,
            // switch to appropriate radio button
            grids.recipientsGrid.selectionChanged(function (values, rows) {

                if (_recipientsGridExecuteSelectionChanged) {
                    if (values.length > 0) {
                        selectBeneficiaryRadio.setChecked()
                        enableDisableBeneficiaryEntryFields(false);
                    }
                }

                _recipientsGridExecuteSelectionChanged = true;
            });

            // Separation Type change event
            function separationTypeChange() {

                // Get selected Separation Type
                var selectedSeparationType = separationTypeSelect.val();

                // Clear Separation Sub Type errors
                separationSubTypeSelect.clearErrors();

                // Show/hide Separation Sub Type based on selected Separation Type
                if (selectedSeparationType == codeValues.disabilityRetirement || selectedSeparationType == codeValues.activeMemberDeath) {

                    // Populate applicable Separation Sub Types based on selected Separation Type
                    separationSubTypeSelectHelper.loadOptionsFrom(
                        backendUrls.getApplicableSeparationSubTypes,
                        {
                            separationType: selectedSeparationType
                        },
                        {
                            withBlank: true
                        },
                        function () {
                            if (selectedSeparationType == codeValues.disabilityRetirement || (selectedSeparationType == codeValues.activeMemberDeath && !flags.deathRecorded)) {
                                separationSubTypeSelectHelper.setValue(codeValues.nonDuty);
                                separationSubTypeHidden.val(codeValues.nonDuty);
                            }
                        });

                    separationSubTypeSelectHelper.setDisabled(selectedSeparationType == codeValues.disabilityRetirement || (selectedSeparationType == codeValues.activeMemberDeath && !flags.deathRecorded));
                    separationSubTypeContainer.show();
                }
                else {
                    separationSubTypeContainer.hide();
                }

                var radioButtonSelection = determineBeneficiaryRadioSelection();

                // Active Member Death does not have the No Beneficiary option.
                // Set to first option (Select Beneficiary) if that is
                // the current selection.
                if (selectedSeparationType == codeValues.activeMemberDeath && radioButtonSelection == Object.keys(beneficiaryOptionEnum)[2]) {
                    selectBeneficiaryRadio.setChecked();
                }

                // Reset beneficiary fields
                beneficiaryRadioToggle(radioButtonSelection);

                // Reset dependant Income Leveling and BackDROP fields
                resetSeparationTypeDependentFields(selectedSeparationType);

                // Show/hide additional sections/fields based on selected Separation Type
                visibility.setVisible(effectiveDatesAndAgesContainer, selectedSeparationType != codeValues.drop);
                visibility.setVisible(dropPlanContainer, selectedSeparationType == codeValues.drop);

                visibility.setVisible(beneficiariesContainer, selectedSeparationType != codeValues.activeMemberDeath);
                visibility.setVisible(recipientsContainer, selectedSeparationType == codeValues.activeMemberDeath);
                visibility.setVisible(noBeneficiaryContainer, selectedSeparationType != codeValues.activeMemberDeath);

                visibility.setVisible(incomeLevelingContainer, selectedSeparationType == codeValues.retirement || selectedSeparationType == codeValues.disabilityRetirement);
                visibility.setVisible(backDropContainer, selectedSeparationType == codeValues.retirement && flags.backDropMonthsExist);

                // reset fields based on Active Member Death
                if (selectedSeparationType == codeValues.activeMemberDeath) {
                    // clear grid/hidden field beneficiary selection
                    resetBeneficiaryGridSelections();
                }

                if (!initialLoad) {
                    eventBanner.removeAllMessages();
                }
            }

            // Reset Separation Type dependent fields
            function resetSeparationTypeDependentFields(separationType) {

                // Reset effective date/age inputs
                if (separationType == codeValues.drop) {
                    separationDateInput.val("").clearErrors();
                    separationAgeInput.val("").clearErrors();
                    benefitEffectiveDateInput.val("").clearErrors();
                    benefitEffectiveAgeInput.val("").clearErrors();
                }
                else {
                    dropEntryDateInput.val("").clearErrors();
                    dropEntryAgeInput.val("").clearErrors();
                }

                // Reset Income Leveling fields
                applyIncomeLevelingCheckBox.setDisabled(false).setChecked(false);
                socialSecurityBenefitAmountInput.setDisabled().val("").clearErrors();
                socialSecurityStartAgeInput.setDisabled().val("").clearErrors();

                // Reset BackDROP fields
                applyBackDropCheckBox.setDisabled(false).setChecked(false);
                backDropMonthsSelectHelper.setDisabled(true).setValue("");
                backDropMonthsSelect.clearErrors();
                backDropDateInput.val("").clearErrors();
                backDropDateHidden.val("").clearErrors();
            }

            // Separation Date change event
            function separationDateChange() {

                // Get entered Separation Date
                var separationDate = separationDateInput.val();

                if (separationDate) {

                    separationDateInput.clearErrors();

                    // Get calculated Separation Age from entered Separation Age
                    var separationAge = calculateAgeFromDates(participant.birthDate, separationDate);

                    // Populate Separation Age with calculated value
                    if (separationAge > 0) {
                        separationAgeInput.val(separationAge).clearErrors();
                    }
                    else {
                        // Populate Separation Age with calculated value
                        separationAgeInput.val("").clearErrors();
                    }

                    // Populate Benefit Effective Date with Separation Date + 1 and trigger it's Date change
                    var benefitEffectiveDate = new Date(separationDate);
                    benefitEffectiveDate.setDate(benefitEffectiveDate.getDate() + 1);
                    benefitEffectiveDateInput.val(new Date(benefitEffectiveDate).toISODateString()).clearErrors();
                    benefitEffectiveDateChange();
                }
            }

            // Separation Age change event
            function separationAgeChange() {

                // Get entered Separation Age
                var separationAge = separationAgeInput.val();

                if (separationAge) {

                    // Get calculated Separation Date from entered Separation Age
                    var separationDate = calculateDateFromAge(participant.birthDate, separationAge);

                    // Populate Separation Date with calculated value
                    separationDateInput.val(separationDate.toISODateString()).clearErrors();

                    // Populate Benefit Effective Date with Separation Date + 1 and trigger it's Date change
                    var benefitEffectiveDate = separationDate;
                    benefitEffectiveDate.setDate(benefitEffectiveDate.getDate() + 1);
                    benefitEffectiveDateInput.val(new Date(benefitEffectiveDate).toISODateString()).clearErrors();
                    benefitEffectiveDateChange();
                }
            }

            // Benefit Effective Date change event
            function benefitEffectiveDateChange() {

                // Get entered Benefit Effective Date
                var benefitEffectiveDate = benefitEffectiveDateInput.val();

                if (benefitEffectiveDate) {

                    benefitEffectiveDateInput.clearErrors();

                    // Get calculated Benefit Effective Age from entered Benefit Effective Date
                    var benefitEffectiveAge = calculateAgeFromDates(participant.birthDate, benefitEffectiveDate);

                    // Populate Benefit Effective Age with calculated value
                    if (benefitEffectiveAge > 0) {
                        benefitEffectiveAgeInput.val(benefitEffectiveAge).clearErrors();
                    }
                    else {
                        benefitEffectiveAgeInput.val("").clearErrors();
                    }
                }

                // Conditionally re-populate BackDROP fields
                if (applyBackDropCheckBox.is(":checked")) {
                    backDropMonthsChange();
                }
            }

            // Benefit Effective Age change event
            function benefitEffectiveAgeChange() {

                // Get entered Benefit Effective Age
                var benefitEffectiveAge = benefitEffectiveAgeInput.val();

                if (benefitEffectiveAge) {

                    // Get calculated Benefit Effective Date from entered Benefit Effective Age
                    var benefitEffectiveDate = calculateDateFromAge(participant.birthDate, benefitEffectiveAge);

                    // Populate Benefit Effective Date with calculated value
                    benefitEffectiveDateInput.val(benefitEffectiveDate.toISODateString()).clearErrors();

                    // Conditionally re-populate BackDROP fields
                    if (applyBackDropCheckBox.is(":checked")) {
                        backDropMonthsChange();
                    }
                }
            }

            // DROP Entry Date change event
            function dropEntryDateChange() {

                var dropEntryDate;

                if (dropEntryDateInput.val() && dropEntryDateInput.valid()) {

                    dropEntryDateInput.clearErrors();

                    // Get entered DROP Entry Date
                    dropEntryDate = dropEntryDateInput.val();

                    // Get calculated DROP Entry Age from entered DROP Entry Date
                    var dropEntryAge = calculateAgeFromDates(participant.birthDate, dropEntryDate);

                    // Populate DROP Entry Age with calculated value
                    if (dropEntryAge > 0) {
                        dropEntryAgeInput.val(dropEntryAge).clearErrors();
                    }
                    else {
                        dropEntryAgeInput.val("").clearErrors();
                    }
                }

                // Populate applicable Drop Plans 
                populateDropPlans(dropEntryDate);
            }

            // DROP Entry Age change event
            function dropEntryAgeChange() {

                // Get entered DROP Entry Age
                var dropEntryAge = dropEntryAgeInput.val();

                if (dropEntryAge) {

                    // Get calculated DROP Entry Date from entered DROP Entry Age
                    var dropEntryDate = calculateDateFromAge(participant.birthDate, dropEntryAge);

                    // Populate DROP Entry Date with calculated value
                    dropEntryDateInput.val(dropEntryDate.toISODateString()).clearErrors();

                    // Populate applicable Drop Plans 
                    populateDropPlans(dropEntryDateInput.val());
                }
            }

            // Populate applicable DROP Plans
            function populateDropPlans(effectiveAsOfDate) {

                if (effectiveAsOfDate) {

                    eventBanner.removeAllMessages();

                    dropPlanSelectHelper.loadOptionsFrom(
                        backendUrls.getApplicableDropPlans,
                        {
                            effectiveAsOfDate: effectiveAsOfDate
                        },
                        {
                            withBlank: true
                        });
                }
                else {
                    dropPlanSelectHelper.clearOptions();
                }
            }

            // BackDROP Months change event
            function backDropMonthsChange() {
                if (benefitEffectiveDateInput.val() && backDropMonthsSelect.val()) {
                    $.ajax({
                        url: backendUrls.getBackDropDate,
                        data: {
                            benefitEffectiveDate: benefitEffectiveDateInput.val(),
                            backDropMonths: backDropMonthsSelect.val()
                        },
                        success: function (data) {
                            backDropDateInput.val(data.backDropDate);
                            backDropDateHidden.val(data.backDropDate);
                        }
                    });
                }
                else {
                    backDropDateInput.val("");
                    backDropDateHidden.val("");
                }
            }

            // Calculate age based on birth date and future asOfDate
            function calculateAgeFromDates(birthDate, asOfDate) {

                // The participant's birth date is fed into the module with time of midnight
                var birthDateJS = new Date(birthDate);

                // The as of date is user input, so it also needs to be instantiated with time of midnight for age calculation
                var asOfDateJS = new Date(asOfDate + 'T00:00:00');

                // Get difference between the years
                var yearsDifference = asOfDateJS.getFullYear() - birthDateJS.getFullYear();
                var birthDateMonth = birthDateJS.getMonth();
                var birthDateDay = birthDateJS.getDate();
                var toDateMonth = asOfDateJS.getMonth();
                var toDateDay = asOfDateJS.getDate();

                // Haven't reached birth day yet this year
                if (birthDateMonth > toDateMonth) {
                    yearsDifference = yearsDifference - 1;
                    yearsDifference = yearsDifference + (365 - (365 * (birthDateMonth / 12.0) + birthDateDay) + (365 * (toDateMonth / 12.0) + toDateDay)) / 365.0
                }
                // Birth day reached this year
                else if (birthDateMonth < toDateMonth) {
                    yearsDifference = yearsDifference + ((365 * (toDateMonth / 12.0) + toDateDay) - (365 * (birthDateMonth / 12.0) + birthDateDay)) / 365.0;
                }
                // Birth day not yet reached, but in month. Make years difference currentage .9
                else if (birthDateDay > toDateDay) {
                    yearsDifference = yearsDifference - .1;
                }
                else {
                    yearsDifference = yearsDifference + (toDateDay - birthDateDay) / 365.0;
                }

                return Math.floor(yearsDifference * 10) / 10;
            }

            // Return date based on supplied startingDate and added number of years
            function calculateDateFromAge(birthDate, age) {

                var birthDateJS = new Date(birthDate);

                // Get number of years to add
                var numAddYears = Math.floor(age);

                // Get number of days to add
                var numAddDays = Math.ceil(365 * (age - Math.floor(age)));

                // Add days to the date
                birthDateJS.setDate(birthDateJS.getDate() + numAddDays);

                // Add years
                var yearsResults = birthDateJS.getFullYear() + numAddYears;
                var monthsResults = birthDateJS.getMonth();

                var resultDate = new Date(yearsResults, monthsResults, birthDateJS.getDate());

                var resultDay = resultDate.getDate();
                var resultMonth = resultDate.getMonth() + 1;
                var resultYear = resultDate.getFullYear();
                var resultDateValue = resultMonth + "/" + resultDay + "/" + resultYear;

                return new Date(resultDateValue);
            }

            // handle change event based on radioButton value
            function beneficiaryRadioChange(e) {
                beneficiaryRadioToggle(e.target.value);
            }

            // determine the radio button selection
            function determineBeneficiaryRadioSelection() {
                // using one of the radio buttons, get the common name for the group
                var radioGroupName = selectBeneficiaryRadio.attr('name');

                return stepContainer.find('input[name=' + radioGroupName + ']:checked').val();
            }

            // with the radio button selection, toggle beneficiary fields
            function beneficiaryRadioToggle(selection) {
                switch (selection) {
                    case Object.keys(beneficiaryOptionEnum)[0]:
                        grids.beneficiariesGrid.selectFirstRow();
                        enableDisableBeneficiaryEntryFields(false);
                        break;

                    case Object.keys(beneficiaryOptionEnum)[1]:
                        resetBeneficiaryGridSelections();
                        enableDisableBeneficiaryEntryFields(true);
                        break;

                    case Object.keys(beneficiaryOptionEnum)[2]:
                        resetBeneficiaryGridSelections();
                        enableDisableBeneficiaryEntryFields(false);
                        break;
                }
            }

            // Reset beneficiary and recipient grid selections
            function resetBeneficiaryGridSelections() {
                grids.beneficiariesGrid.selectedValues = null;
                beneficiaryAccountPartyKeyHidden.val("").clearErrors();

                grids.recipientsGrid.selectedValues = null;
            }

            // Enable/Disable/Reset manual beneficiary entry fields 
            function enableDisableBeneficiaryEntryFields(enable) {
                // only reset fields if disabling them
                if (!enable) {
                    beneficiaryNameInput.val("").clearErrors();
                    beneficiaryNameInputHidden.val("").clearErrors();
                    beneficiaryBirthDateInput.val("").clearErrors();
                    beneficiaryBirthDateInputHidden.val("").clearErrors();
                    beneficiaryRelationshipSelectHelper.setValue("");
                    beneficiaryRelationshipSelect.clearErrors();
                    beneficiaryRelationshipSelectHidden.val("").clearErrors();
                    beneficiaryFTSCheckBox.setChecked(false);
                    beneficiaryFTSCheckBoxHidden.setChecked(false);
                }

                beneficiaryNameInput.setDisabled(!enable);
                beneficiaryBirthDateInput.setDisabled(!enable);
                beneficiaryRelationshipSelectHelper.setDisabled(!enable);
                beneficiaryFTSCheckBox.setDisabled(!enable);
            }

            //Supress enter key press 
            function suppressEnterKeyPress(event) {
                if (event.which == 13) {
                    return false;
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);